import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ChevronLeft, ArrowUpRight } from "lucide-react";
import { MaskedReveal, FadeUp } from "@/components/motion/Reveal";
import { BLOGS } from "@/data/site";

export default function BlogPost() {
  const { slug } = useParams();
  const post = BLOGS.find(b => b.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;
  return (
    <div data-testid={`blog-post-${slug}`}>
      <section className="pt-40 pb-12">
        <div className="mx-auto max-w-[900px] px-6 md:px-10">
          <Link to="/blog" className="editorial-link mono text-xs uppercase tracking-[0.28em] inline-flex items-center gap-2 mb-8">
            <ChevronLeft className="h-4 w-4" /> Back to Journal
          </Link>
          <div className="mono text-xs uppercase tracking-[0.28em] text-gold mb-6">{post.category} · {new Date(post.date).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" })}</div>
          <MaskedReveal as="h1" className="serif text-5xl md:text-7xl leading-[0.98]" lines={[post.title]} />
          <FadeUp delay={0.4} className="mt-8 text-[hsl(var(--muted-foreground))]">{post.excerpt}</FadeUp>
        </div>
      </section>
      <section className="pb-16">
        <div className="mx-auto max-w-[1200px] px-6 md:px-10">
          <div className="aspect-[16/9] overflow-hidden hairline border">
            <img src={post.hero} alt={post.title} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
      <section className="pb-24">
        <article className="mx-auto max-w-[720px] px-6 md:px-10 space-y-6">
          {post.body.map((p, i) => (
            <FadeUp key={i} delay={i * 0.05}>
              <p className={`${i === 0 ? "serif italic text-2xl leading-relaxed" : "text-[17px] leading-[1.85]"}`}>{p}</p>
            </FadeUp>
          ))}
          <FadeUp className="pt-8 border-t hairline">
            <Link to="/contact" className="btn-ink" data-testid="blogpost-consult">Discuss your matter <ArrowUpRight className="h-4 w-4" /></Link>
          </FadeUp>
        </article>
      </section>
    </div>
  );
}
